import { useEffect, useState } from "react";
import { api } from "./api";
import { SignIn } from "./SignIn";
import { Queue } from "./Queue";

export function App() {
  const [auth, setAuth] = useState<"loading" | "in" | "out">("loading");

  useEffect(() => {
    api
      .me()
      .then((r) => setAuth(r.authenticated ? "in" : "out"))
      .catch(() => setAuth("out"));
  }, []);

  if (auth === "loading") {
    return (
      <div className="flex min-h-dvh items-center justify-center text-sm text-[color:var(--color-ink-soft)]">
        <span className="animate-pulse-soft">Checking session…</span>
      </div>
    );
  }

  if (auth === "out") {
    return <SignIn onSignedIn={() => setAuth("in")} />;
  }

  return <Queue onLogout={() => setAuth("out")} />;
}
